<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
<div fxLayout="row" style="margin-top: 15px; margin-bottom: 10px; margin-left: 10px; padding-left: 15px; padding-right: 15px;">
  <div fxFlex="50">
    <button mat-raised-button color="basic" (click)="returnBack()" style="margin-right: 20px;">Back</button>

  </div>
  <div fxFlex="50" class="text-right">

    <ng-container *ngIf="bankTransferLoad">

      <span *ngIf="bankTransferLoad?.card"></span>
      <span *ngIf="customer" style="margin-left: 15px; margin-right: 15px;">
        <a routerLink="/customers-overview/{{ customer.id }}">Customer Overview: {{ customer.firstName }} {{ customer.lastName }} </a>
      </span>

      <ng-container *ngIf="bankTransferLoad">
        <span style="display: inline-block; background-color: #fc5c5c; border-radius: 3px; padding: 2px 5px; margin: 0 5px; font-size: .8em" *ngIf="bankTransferLoad.isMarkedForRefund && !bankTransferLoad.isRefunded">Marked for refund</span>
        <span style="display: inline-block; background-color: #ff1f1f; border-radius: 3px; padding: 2px 5px; margin: 0 5px; font-size: .8em" *ngIf="bankTransferLoad.isMarkedForRefund && bankTransferLoad.isRefunded">Refunded</span>

        <span style="display: inline-block; background-color: orange; border-radius: 3px; padding: 2px 5px; margin: 0 5px; font-size: .8em" *ngIf="(!bankTransferLoad.isMarkedForRefund) && (!bankTransferLoad.isExported || !bankTransferLoad.isConfirmed)">Pending</span>

        <span style="display: inline-block; background-color: lightskyblue; border-radius: 3px; padding: 2px 5px; margin: 0 5px; font-size: .8em" *ngIf="bankTransferLoad.isExported && !bankTransferLoad.isConfirmed">Exported</span>
        <span style="display: inline-block; background-color: lightskyblue; border-radius: 3px; padding: 2px 5px; margin: 0 5px; font-size: .8em" *ngIf="bankTransferLoad.isConfirmed">Confirmed</span>

      </ng-container>

      <!--<a [disabled]="isLoading || isBusy" mat-raised-button color="blue" routerLink="edit" *ngIf="isAdmin()">
        <mat-icon>edit</mat-icon>
        Edit
      </a>-->
    </ng-container>
  </div>
</div>


<div fxLayout="row" style="margin-top: 15px; margin-bottom: 10px; margin-left: 10px; padding-left: 15px; padding-right: 15px;">

  <div fxFlex="40">

    <div *ngIf="decisionNecessary">
      <mat-card class="content-card">
        <mat-card-header>
          <mat-card-title>
            <h5>
              Decision
            </h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div style="margin: 15px;">
            <div fxLayout="row" class="list-item">
              <label fxFlex="40" class="secondary">
                Decision
              </label>
              <label fxFlex="60">
                <mat-select placeholder="Select decision" [(value)]="decision">
                  <mat-option [value]="0">Pending</mat-option>
                  <mat-option [value]="1">Approve</mat-option>
                  <mat-option [value]="2">Decline</mat-option>
                </mat-select>
              </label>
            </div>
            <div fxLayout="row" class="list-item">
              <label fxFlex="40" class="secondary">
                Comment
              </label>
              <label fxFlex="60">
                <textarea rows="6" style="width: 100%" matInput placeholder="Comment" [(ngModel)]="decisionComment"></textarea>
                <div *ngIf="decision === 2" style="background-color: rgba(255,165,0,0.49); padding: 4px 10px; border-radius: 3px;">Mandatory for declines</div>
              </label>
            </div>

            <div fxLayout="row" class="list-item" *ngIf="decision === 1">
              <label fxFlex="40" class="secondary">
                Customer yearly income
              </label>
              <label fxFlex="60">
                <input type="number" style="width: 100%" matInput placeholder="Income" [(ngModel)]="decisionCustomerIncome" />
              </label>
            </div>
            <div fxLayout="row" class="list-item" *ngIf="decision === 1">
              <label fxFlex="40" class="secondary">
                Main income source
              </label>
              <label fxFlex="60">
                <mat-select placeholder="Main income source" [(ngModel)]="decisionCustomerIncomeType">
                  <mat-option [value]="0">None</mat-option>
                  <mat-option [value]="1">Employment</mat-option>
                  <mat-option [value]="2">Pension</mat-option>
                  <mat-option [value]="3">CapitalAssets</mat-option>
                  <mat-option [value]="4">RentalAndLeasing</mat-option>
                  <mat-option [value]="5">Agriculture and Forestry</mat-option>
                  <mat-option [value]="6">Independent Work</mat-option>
                  <mat-option [value]="7">Commercial Operation</mat-option>
                </mat-select>
              </label>
            </div>

            <div fxLayout="row" class="list-item">
              <label fxFlex="40" class="secondary">

              </label>
              <label fxFlex="60">

                <button [class.spinner]="isSavingDecision" [disabled]="isSavingDecision || !decision || (decisionComment == '' && decision === 2) || notAllFilesStatusSet" mat-flat-button [color]="decision === 1 ? 'primary' : 'accent'" (click)="saveDecision()">
                  <mat-icon>save</mat-icon>
                  <ng-container *ngIf="decision === 0">
                    Save
                  </ng-container>
                  <ng-container *ngIf="decision === 1">
                    Approve
                  </ng-container>
                  <ng-container *ngIf="decision === 2">
                    Decline
                  </ng-container>
                   and inform customer
                </button>
              </label>
            </div>
          </div>

        </mat-card-content>

      </mat-card>
    </div>

    <div>
      <mat-card class="content-card">
        <mat-card-header>
          <mat-card-title-group>
            <mat-card-title>
              <h5>Uploaded Files</h5>
            </mat-card-title>
          </mat-card-title-group>
          <div fxFlex></div>
          <div fxLayoutAlign="center center">
            <div *ngIf="notAllFilesStatusSet" style="background-color: rgba(255,165,0,0.49); padding: 4px 10px; border-radius: 3px;">All files need to be set to Success or Failed</div>
          </div>
        </mat-card-header>
        <mat-card-content>

          <ng-container *ngFor="let f of uploadedFiles">

            <div fxLayout="row">
              <div fxFlex="15">{{ datePipe.transform(f.uploadDate, "dd.MM.yyyy") }}</div>
              <div fxFlex>{{ f.originalFileName}}</div>
              <div fxFlex="20">
                <app-tri-state-checkbox *ngIf="f.mailSentDate == null" style="margin-right: 3px;" [(ngModel)]="f.isSuccess" (click)="handleFileStatusChange()">
                  <label *ngIf="f.isSuccess == true">Success</label>
                  <label *ngIf="f.isSuccess == false">Failed</label>
                  <label *ngIf="f.isSuccess == null">Pending</label>
                </app-tri-state-checkbox>
                <ng-container *ngIf="f.mailSentDate != null">
                  <label *ngIf="f.isSuccess == true">Success</label>
                  <label *ngIf="f.isSuccess == false">Failed</label>
                  <label *ngIf="f.isSuccess == null">Pending</label>
                </ng-container>
              </div>
              <div fxFlex="10" style="text-align: right;">
                <button mat-mini-fab color="primary" (click)="previewFile(f.id)" aria-label="preview">
                  <mat-icon matSuffix>play_arrow</mat-icon>
                </button>
              </div>
            </div>
          </ng-container>

        </mat-card-content>

      </mat-card>
    </div>

  </div>

  <div fxFlex="60">

    <div *ngIf="previewFileOpen">
      <mat-card *ngIf="customer" class="content-card">
        <mat-card-header>
          <mat-card-title-group>
            <mat-card-title>
              <h5 *ngIf="filename == null">Preview</h5>
              <h5 *ngIf="filename != null">{{ filename }}</h5>

              <mat-error *ngIf="errorMsg != null">{{errorMsg}}</mat-error>
            </mat-card-title>
          </mat-card-title-group>
          <div fxFlex></div>
          <div fxLayoutAlign="center center">
            <button mat-flat-button (click)="closePreview()"><mat-icon>clear</mat-icon> Close</button>
          </div>

        </mat-card-header>
        <mat-card-content style="">

          <!--
          <div class="resp-container">
            <iframe class="resp-iframe" src="https://www.youtube.com/embed/dQw4w9WgXcQ" gesture="media"  allow="encrypted-media" allowfullscreen [hidden]="isFrameHidden" frameBorder="1" [src]="urlSafe"></iframe>
          </div>
          -->

          <iframe class="resp-iframe" height="1000" width="100%" [hidden]="isFrameHidden" frameBorder="1" [src]="urlSafe" ></iframe>
          <img [src]="urlSafe" style="width: 100%; height:auto;" [hidden]="isImgHidden"/>



        </mat-card-content>
      </mat-card>
    </div>

    <div *ngIf="!previewFileOpen">
      <mat-card class="content-card">
        <mat-card-header>
          <mat-card-title>
            <h5>
              <ng-container *ngIf="bankTransferLoad && bankTransferLoad.loadType == 1">Bank transfer</ng-container>
              <ng-container *ngIf="bankTransferLoad && bankTransferLoad.loadType == 2">Partner</ng-container>
              load
            </h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="list-item" fxLayout="row">
            <label fxFlex="35" class="secondary">Created</label>
            <label fxFlex="65" *ngIf="bankTransferLoad">{{ this.datePipe.transform(bankTransferLoad.createDate, "dd.MM.yyy") }}</label>
          </div>
          <div class="list-item" fxLayout="row">
            <label fxFlex="35" class="secondary">Statement Date</label>
            <label fxFlex="65" *ngIf="bankTransferLoad">{{ this.datePipe.transform(bankTransferLoad.statementDate, "dd.MM.yyy") }}</label>
          </div>
          <div class="list-item" fxLayout="row">
            <label fxFlex="35" class="secondary">Amount</label>
            <label fxFlex="65" *ngIf="bankTransferLoad">{{ bankTransferLoad.amount.formatMoneyCcy(bankTransferLoad.currencyCode) }}</label>
          </div>
          <div class="list-item" fxLayout="row">
            <label fxFlex="35" class="secondary">Load fee</label>
            <label fxFlex="65" *ngIf="bankTransferLoad">{{ bankTransferLoad.loadFee.formatMoneyCcy(bankTransferLoad.currencyCode) }}</label>
          </div>
          <div class="list-item" fxLayout="row">
            <label fxFlex="35" class="secondary">Amount to load</label>
            <label fxFlex="65" *ngIf="bankTransferLoad">{{ bankTransferLoad.amountToLoad.formatMoneyCcy(bankTransferLoad.currencyCode) }}</label>
          </div>

          <div class="list-item" fxLayout="row">
            <label fxFlex="35" class="secondary">Amount already loaded</label>
            <label fxFlex="65" *ngIf="bankTransferLoad">
              <ng-container *ngIf="bankTransferLoad.amountAlreadyLoaded > 0; else notYetLoaded">
                {{ bankTransferLoad.amountAlreadyLoaded.formatMoneyCcy(bankTransferLoad.currencyCode) }}
              </ng-container>
              <ng-template #notYetLoaded>
                -
              </ng-template>
            </label>
          </div>

          <div class="list-item" fxLayout="row">
            <label fxFlex="35" class="secondary">Next Load delayed until</label>
            <label fxFlex="65" *ngIf="bankTransferLoad">
              <ng-container *ngIf="bankTransferLoad.delayNextLoadUntil; else noDelay">
                {{ bankTransferLoad.delayNextLoadUntil | date: "dd.MM.yyyy HH:mm" }}
              </ng-container>
              <ng-template #noDelay>
                -
              </ng-template>
            </label>
          </div>

          <div class="list-item" fxLayout="row">
            <label fxFlex="35" class="secondary">Card</label>
            <label fxFlex="65" *ngIf="bankTransferLoad">{{ bankTransferLoad.card?.token }}</label>
          </div>
          <div class="list-item" fxLayout="row">
            <label fxFlex="35" class="secondary">
              Risk<br />

            </label>
            <label fxFlex="65" *ngIf="bankTransferLoad">
              <div *ngIf="bankTransferLoad.riskLevel === 0" style="background-color: forestgreen; color: white; border-radius: 5px; font-weight: bold; padding: 4px;">Low</div>
              <div *ngIf="bankTransferLoad.riskLevel === 1" style="background-color: orange; color: black; border-radius: 5px; font-weight: bold; padding: 4px;">Medium</div>
              <div *ngIf="bankTransferLoad.riskLevel === 2" style="background-color: red; color: white; border-radius: 5px; font-weight: bold; padding: 4px;">High</div>
              <div *ngIf="bankTransferLoad.riskLevel === 99" style="background-color: black; color: white; border-radius: 5px; font-weight: bold; padding: 4px;">Unknown</div>

              <hr />

              <ng-container *ngIf="bankTransferLoad.riskLevelAutomaticComment">
                <div *ngFor="let cmt of bankTransferLoad.riskLevelAutomaticComment.split('\n')">
                  {{cmt}}
                </div>
              </ng-container>


              <div style="font-size: 9px; margin-top: 10px;">
                (Above information valid at the time of the load)
              </div>

            </label>
          </div>

          <div class="list-item" fxLayout="row" *ngIf="bankTransferLoad && bankTransferLoad.isDocsRequested">
            <label fxFlex="35" class="secondary">SOF requested</label>
            <label fxFlex="65" *ngIf="bankTransferLoad">Yes</label>
          </div>

          <div class="list-item" fxLayout="row">
            <label fxFlex="35" class="secondary">Status</label>
            <label fxFlex="65" *ngIf="bankTransferLoad">
              <app-load-status-info [bankTransferLoad]="bankTransferLoad" [customer]="customer"></app-load-status-info>
              <div *ngIf="bankTransferLoad.amountAlreadyLoaded > 0 && bankTransferLoad.amountAlreadyLoaded < bankTransferLoad.amountToLoad">
                <mat-icon style="color: deeppink;">call_split</mat-icon> This load is a partial load
              </div>

            </label>
          </div>

          <div class="list-item" fxLayout="row" *ngIf="bankTransferLoad && bankTransferLoad.exportedDate">
            <label fxFlex="35" class="secondary">Exported on</label>
            <label fxFlex="65">
              {{ this.datePipe.transform(bankTransferLoad.exportedDate, 'dd.MM.yyyy HH:mm') }}
            </label>
          </div>

          <div class="list-item" fxLayout="row" *ngIf="bankTransferLoad && bankTransferLoad.markedForRefundDate">
            <label fxFlex="35" class="secondary">Marked for refund on</label>
            <label fxFlex="65">
              {{ this.datePipe.transform(bankTransferLoad.markedForRefundDate, 'dd.MM.yyyy HH:mm') }}
            </label>
          </div>

          <div class="list-item" fxLayout="row" *ngIf="bankTransferLoad && bankTransferLoad.refundedDate">
            <label fxFlex="35" class="secondary">Refunded on</label>
            <label fxFlex="65">
              {{ this.datePipe.transform(bankTransferLoad.refundedDate, 'dd.MM.yyyy HH:mm') }}
            </label>
          </div>

          <div class="list-item" fxLayout="row" *ngIf="bankTransferLoad && bankTransferLoad.confirmedDate">
            <label fxFlex="35" class="secondary">Confirmed on</label>
            <label fxFlex="65">
              {{ this.datePipe.transform(bankTransferLoad.confirmedDate, 'dd.MM.yyyy HH:mm') }}
            </label>
          </div>

        </mat-card-content>

      </mat-card>



      <mat-card class="content-card">
        <mat-card-header>
          <mat-card-title>
            <h5>Transaction</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <ng-container *ngIf="isLoading || trustPayTransaction">
            <div class="list-item" fxLayout="row" *ngFor="let field of fieldsTransaction ">
              <label fxFlex="35" class="secondary">{{ field.header }}</label>
              <label fxFlex="65" *ngIf="trustPayTransaction">{{ field.cell(trustPayTransaction) }}</label>
            </div>
          </ng-container>
          <ng-container *ngIf="!isLoading && !trustPayTransaction">
            <div style="margin-left: 15px;">(no transaction)</div>
          </ng-container>
        </mat-card-content>
      </mat-card>
    </div>
  </div>


</div>
